import { render, staticRenderFns } from "./offer-configuration-duration-select.vue?vue&type=template&id=237d63cf&"
import script from "./offer-configuration-duration-select.vue?vue&type=script&lang=js&"
export * from "./offer-configuration-duration-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports